__turbopack_context__.v({
  "capitalize": "NavBarOrderTimeSwitch-module-scss-module__zWvF-q__capitalize",
  "container": "NavBarOrderTimeSwitch-module-scss-module__zWvF-q__container",
  "navBar": "NavBarOrderTimeSwitch-module-scss-module__zWvF-q__navBar",
  "singleOption": "NavBarOrderTimeSwitch-module-scss-module__zWvF-q__singleOption",
});
